/* 
  sov — telemetria card product
  - emissione via gtag (ga4) e customevent dom.
  - eventi:
      - card_product_impression
      - card_product_engaged
      - card_product_click
      - card_product_quick_add_click
      - card_product_variant_thumb_click
      - card_product_variant_more_click
      - card_product_wishlist_click
      - card_product_gallery_view
      - card_product_gallery_click
      - card_product_gallery_swipe
  - ultimo aggiornamento: 2025-12-20 14:00 europe/rome
*/
(function () {
  const SELECTOR = '.sov-card-gallery';

  const __sovCardImpressionSeen = new WeakSet();
  let __sovCardImpressionObserver = null;

  function sovTelemetry(eventName, detail) {
    try {
      var params = Object.assign(
        { component: 'card_product_card' },
        detail || {}
      );

      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
      }

      window.dispatchEvent(
        new CustomEvent(eventName, {
          detail: Object.assign({ event: eventName }, params)
        })
      );
    } catch (_) {}
  }

  function sovGetCardContainer(el) {
    return (
      (el && el.closest && el.closest('[data-sov-cont-grid]')) ||
      (el && el.closest && el.closest('#product-grid')) ||
      (el && el.closest && el.closest('.collection')) ||
      document.body
    );
  }

  function sovGetCardSource(container) {
    if (!container) return 'unknown';
    if (container.id === 'product-grid') return 'collection_grid';
    if (container.hasAttribute && container.hasAttribute('data-sov-cont-grid')) return 'continuation_grid';
    return 'unknown';
  }

  function sovGetCardPosition(container, cardWrapper) {
    try {
      if (!container || !cardWrapper || !container.querySelectorAll) return null;
      var nodes = container.querySelectorAll('.card-wrapper');
      var idx = Array.prototype.indexOf.call(nodes, cardWrapper);
      return idx >= 0 ? (idx + 1) : null;
    } catch (_) {
      return null;
    }
  }

  function sovParseProductHandleFromHref(href) {
    try {
      if (!href) return null;
      var m = String(href).match(/\/products\/([^\/\?\#]+)/i);
      return m && m[1] ? m[1] : null;
    } catch (_) {
      return null;
    }
  }

  function sovEnsureImpressionObserver() {
    if (__sovCardImpressionObserver) return __sovCardImpressionObserver;

    if (typeof IntersectionObserver !== 'function') {
      __sovCardImpressionObserver = {
        observe: function () {},
        unobserve: function () {}
      };
      return __sovCardImpressionObserver;
    }

    __sovCardImpressionObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var el = entry.target;
          if (__sovCardImpressionSeen.has(el)) return;
          __sovCardImpressionSeen.add(el);

          var pid = el.getAttribute('data-sov-product-id') || null;
          var ph = el.getAttribute('data-sov-product-handle') || null;
          var source = el.getAttribute('data-sov-source') || 'unknown';
          var position = el.getAttribute('data-sov-position') || null;

          sovTelemetry('card_product_impression', {
            product_id: pid,
            product_handle: ph,
            source: source,
            position: position ? Number(position) : null
          });

          __sovCardImpressionObserver.unobserve(el);
        });
      },
      { threshold: 0.35 }
    );

    return __sovCardImpressionObserver;
  }

  function initOne(root) {
    if (!root || root.__sovCardInited) return;
    root.__sovCardInited = true;

    const rail = root.querySelector('.sov-card-rail');
    const prev = root.querySelector('.sov-card-nav--prev');
    const next = root.querySelector('.sov-card-nav--next');
    if (!rail || !rail.children.length) return;

    const productId = root.getAttribute('data-product-id') || null;
    const productHandle = root.getAttribute('data-product-handle') || null;

    let engagedFired = false;
    function fireEngaged(trigger) {
      if (engagedFired) return;
      engagedFired = true;

      sovTelemetry('card_product_engaged', {
        product_id: productId,
        product_handle: productHandle,
        trigger: trigger || null
      });
    }

    const wrap = root.closest('.card-wrapper');
    const href =
      root.getAttribute('data-pdp-href') ||
      (wrap && wrap.querySelector('a.full-unstyled-link') && wrap.querySelector('a.full-unstyled-link').getAttribute('href')) ||
      null;

    const container = sovGetCardContainer(wrap || root);
    const source = sovGetCardSource(container);
    const position = sovGetCardPosition(container, wrap);

    if (wrap) {
      wrap.setAttribute('data-sov-product-id', productId || '');
      wrap.setAttribute('data-sov-product-handle', productHandle || '');
      wrap.setAttribute('data-sov-source', source || 'unknown');

      if (position !== null && position !== undefined) {
        wrap.setAttribute('data-sov-position', String(position));
      }

      if (typeof IntersectionObserver === 'function') {
        sovEnsureImpressionObserver().observe(wrap);
      } else {
        if (!__sovCardImpressionSeen.has(wrap)) {
          __sovCardImpressionSeen.add(wrap);

          sovTelemetry('card_product_impression', {
            product_id: productId,
            product_handle: productHandle,
            source: source,
            position: position
          });
        }
      }
    }

    const viewport = root;
    viewport.style.touchAction = 'pan-y';

    let idx = 0;
    let K = rail.children.length;
    let hasInitialGo = false;
    let lastDragAt = 0;

    function go(i, input) {
      var from = idx;

      i = Math.max(0, Math.min(K - 1, i));
      idx = i;

      rail.style.transition = 'transform .35s ease';
      rail.style.transform = 'translateX(' + (-100 * idx) + '%)';

      if (hasInitialGo && idx !== from) {
        sovTelemetry('card_product_gallery_view', {
          product_id: productId,
          product_handle: productHandle,
          from_index: from,
          to_index: idx,
          input: input || null,
          frames_count: K,
          source: source,
          position: position
        });

        fireEngaged('gallery_view');
      }

      if (!hasInitialGo) {
        hasInitialGo = true;
      }
    }

    let dragging = false;
    let moved = false;
    let startX = 0;
    let dx = 0;
    let vw = 0;

    function onDown(e) {
      const t = e.touches ? e.touches[0] : e;
      startX = t.clientX;
      dx = 0;
      moved = false;
      dragging = true;
      vw = viewport.clientWidth || 1;
      rail.style.transition = 'none';
    }

    function onMove(e) {
      if (!dragging) return;
      const t = e.touches ? e.touches[0] : e;
      dx = t.clientX - startX;

      if (Math.abs(dx) > 6) moved = true;

      const pct = (dx / (vw || 1)) * 100;
      rail.style.transform = 'translateX(' + ((-100 * idx) + pct) + '%)';

      if (e.cancelable) e.preventDefault();
    }

    function onUp() {
      if (!dragging) return;
      dragging = false;

      rail.style.transition = 'transform .35s ease';

      const TH = Math.max(40, (vw || 1) * 0.15);
      const from = idx;

      if (Math.abs(dx) >= TH) {
        const dir = dx < 0 ? +1 : -1;
        const to = Math.max(0, Math.min(K - 1, from + dir));

        go(to, 'swipe');
        lastDragAt = Date.now();

        sovTelemetry('card_product_gallery_swipe', {
          product_id: productId,
          product_handle: productHandle,
          from_index: from,
          to_index: to,
          direction: dir > 0 ? 'next' : 'prev',
          input: 'swipe',
          frames_count: K,
          source: source,
          position: position
        });

        fireEngaged('gallery_swipe');
      } else {
        go(from, 'swipe_cancel');
      }

      if (moved) {
        const kill = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
        };

        viewport.addEventListener('click', kill, true);
        setTimeout(function () {
          viewport.removeEventListener('click', kill, true);
        }, 0);
      }
    }

    try {
      viewport.addEventListener('pointerdown', onDown, { passive: true });
      viewport.addEventListener('pointermove', onMove, { passive: false });
      viewport.addEventListener('pointerup', onUp, { passive: true });
      viewport.addEventListener('pointercancel', onUp, { passive: true });
    } catch (_) {
      viewport.addEventListener('touchstart', onDown, { passive: true });
      viewport.addEventListener('touchmove', onMove, { passive: false });
      viewport.addEventListener('touchend', onUp, { passive: true });
      viewport.addEventListener('touchcancel', onUp, { passive: true });
      viewport.addEventListener('mousedown', onDown, { passive: true });
      window.addEventListener('mousemove', onMove, { passive: false });
      window.addEventListener('mouseup', onUp, { passive: true });
    }

    viewport.addEventListener(
      'click',
      function (ev) {
        if (Date.now() - lastDragAt < 280) return;

        const anchor = ev.target && ev.target.closest('.sov-card-rail > .sov-card-stretched-link');
        if (!anchor) return;

        const index = Array.prototype.indexOf.call(rail.children, anchor);
        if (index < 0) return;

        sovTelemetry('card_product_gallery_click', {
          product_id: productId,
          product_handle: productHandle,
          index: index,
          frames_count: rail.children.length,
          source: source,
          position: position
        });

        fireEngaged('gallery_click');
      },
      true
    );

    function blockDown(ev) {
      ev.stopPropagation();
    }

    if (prev) {
      ['pointerdown', 'touchstart', 'mousedown'].forEach(function (t) {
        prev.addEventListener(t, blockDown);
      });

      prev.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();

        const from = idx;
        const to = Math.max(0, Math.min(K - 1, from - 1));
        if (to === from) return;

        go(to, 'caret');

        sovTelemetry('card_product_gallery_swipe', {
          product_id: productId,
          product_handle: productHandle,
          from_index: from,
          to_index: to,
          direction: 'prev',
          input: 'caret',
          frames_count: K,
          source: source,
          position: position
        });

        fireEngaged('gallery_caret');
      });
    }

    if (next) {
      ['pointerdown', 'touchstart', 'mousedown'].forEach(function (t) {
        next.addEventListener(t, blockDown);
      });

      next.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();

        const from = idx;
        const to = Math.max(0, Math.min(K - 1, from + 1));
        if (to === from) return;

        go(to, 'caret');

        sovTelemetry('card_product_gallery_swipe', {
          product_id: productId,
          product_handle: productHandle,
          from_index: from,
          to_index: to,
          direction: 'next',
          input: 'caret',
          frames_count: K,
          source: source,
          position: position
        });

        fireEngaged('gallery_caret');
      });
    }

    if (wrap) {
      wrap.addEventListener(
        'click',
        function (ev) {
          if (ev.defaultPrevented) return;

          var t = ev.target;

          var qaBtn = t && t.closest && t.closest('.sov-qa-bag');
          if (qaBtn) {
            sovTelemetry('card_product_quick_add_click', {
              product_id: productId,
              product_handle: productHandle,
              source: source,
              position: position
            });

            fireEngaged('quick_add');
            return;
          }

          var wl = t && t.closest && t.closest('.sov-wishlist-anchor');
          if (wl) {
            sovTelemetry('card_product_wishlist_click', {
              product_id: productId,
              product_handle: productHandle,
              source: source,
              position: position
            });

            fireEngaged('wishlist');
            return;
          }

          var thumb = t && t.closest && t.closest('.sov-family-thumb-link');
          if (thumb) {
            var thref = thumb.getAttribute('href') || null;
            var targetHandle = sovParseProductHandleFromHref(thref);

            sovTelemetry('card_product_variant_thumb_click', {
              product_id: productId,
              product_handle: productHandle,
              target_handle: targetHandle,
              href: thref,
              source: source,
              position: position
            });

            fireEngaged('variant_thumb');
            return;
          }

          var more = t && t.closest && t.closest('.sov-variant-thumb--more a');
          if (more) {
            var mhref = more.getAttribute('href') || null;

            sovTelemetry('card_product_variant_more_click', {
              product_id: productId,
              product_handle: productHandle,
              href: mhref,
              source: source,
              position: position
            });

            fireEngaged('variant_more');
            return;
          }

          var titleLink = t && t.closest && t.closest('a.full-unstyled-link');
          if (titleLink && !(t.closest && t.closest('.sov-card-gallery'))) {
            var lh = titleLink.getAttribute('href') || href || null;

            sovTelemetry('card_product_click', {
              product_id: productId,
              product_handle: productHandle,
              href: lh,
              input: 'link',
              source: source,
              position: position
            });

            fireEngaged('card_click');
            return;
          }

          if (
            (t.closest && t.closest('.sov-card-gallery,.sov-card-nav')) ||
            (t.closest && t.closest('a,button,[role="button"],input,select,textarea')) ||
            (t.closest && t.closest('.sov-wishlist-anchor,.sov-variant-thumbs,.quick-add,[data-no-card-nav]'))
          ) {
            return;
          }

          if (href) {
            if (ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;

            sovTelemetry('card_product_click', {
              product_id: productId,
              product_handle: productHandle,
              href: href,
              input: 'card_area',
              source: source,
              position: position
            });

            fireEngaged('card_click');

            ev.preventDefault();
            window.location.href = href;
          }
        },
        true
      );
    }

    go(0, 'init');
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initOne);
  }

  document.addEventListener('DOMContentLoaded', initAll, { once: true });
  window.addEventListener('load', initAll, { once: true });
  setTimeout(initAll, 100);
  setTimeout(initAll, 500);
  setTimeout(initAll, 1200);
  setTimeout(initAll, 2500);

  document.addEventListener('sov:edb:mounted', function (ev) {
    var root = ev && ev.detail && ev.detail.root;
    if (!root) return;
    var g = root.querySelector && root.querySelector(SELECTOR);
    if (g) initOne(g);
  });

  document.addEventListener('sov:collection:chunk:mounted', function (ev) {
    var root = ev && ev.detail && ev.detail.root;
    if (!root) return;
    var nodes = root.querySelectorAll(SELECTOR);
    nodes.forEach(initOne);
  });

  document.addEventListener('sov:facets:block:mounted', function (ev) {
    var root = ev && ev.detail && ev.detail.root;
    if (!root) return;
    var nodes = root.querySelectorAll(SELECTOR);
    nodes.forEach(initOne);
  });

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (m.addedNodes && m.addedNodes.length) {
        initAll();
        break;
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();

(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 900px)').matches;
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function getTranslateX(element) {
    var transform = window.getComputedStyle(element).transform;
    if (!transform || transform === 'none') {
      return 0;
    }

    var matrix2d = transform.match(/matrix\(([^)]+)\)/);
    if (matrix2d) {
      var parts2d = matrix2d[1].split(',').map(function (x) {
        return parseFloat(x);
      });
      return isFinite(parts2d[4]) ? parts2d[4] : 0;
    }

    var matrix3d = transform.match(/matrix3d\(([^)]+)\)/);
    if (matrix3d) {
      var parts3d = matrix3d[1].split(',').map(function (x) {
        return parseFloat(x);
      });
      return isFinite(parts3d[12]) ? parts3d[12] : 0;
    }

    return 0;
  }

  function wireGallery(gallery) {
    if (!gallery || gallery.__sovMiniSliderWired) {
      return;
    }
    gallery.__sovMiniSliderWired = true;

    var bar = gallery.querySelector('[data-sov-card-mini-slider]');
    if (!bar) {
      return;
    }

    var track = bar.querySelector('.sov-mini-slider__track');
    var knob = bar.querySelector('.sov-mini-slider__knob');
    var rail = gallery.querySelector('.sov-card-rail');

    if (!track || !knob || !rail) {
      return;
    }

    var frames = rail.children ? rail.children.length : 0;
    if (frames <= 1) {
      bar.setAttribute('hidden', '');
      return;
    }

    function update() {
      if (!isMobile()) {
        bar.setAttribute('hidden', '');
        window.requestAnimationFrame(update);
        return;
      }

      bar.removeAttribute('hidden');

      var trackWidth = track.clientWidth || 1;
      var knobWidth = Math.max(16, trackWidth / frames);
      knob.style.width = knobWidth + 'px';

      var galleryWidth = gallery.clientWidth || 1;
      var tx = getTranslateX(rail);
      var rawIndex = -tx / galleryWidth;
      var index = clamp(Math.round(rawIndex), 0, frames - 1);

      var maxTranslateX = Math.max(0, trackWidth - knobWidth);
      var ratio = frames > 1 ? index / (frames - 1) : 0;
      var targetX = maxTranslateX * ratio;

      knob.style.transform = 'translateX(' + targetX + 'px)';

      window.requestAnimationFrame(update);
    }

    window.requestAnimationFrame(update);
  }

  function scan(root) {
    var scope = root || document;
    var galleries = scope.querySelectorAll('.sov-card-gallery');
    if (!galleries || !galleries.length) {
      return;
    }
    galleries.forEach(function (gallery) {
      wireGallery(gallery);
    });
  }

  function setupMutationObserver() {
    if (!('MutationObserver' in window)) {
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || !m.addedNodes.length) {
          continue;
        }

        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (!node || node.nodeType !== 1) {
            continue;
          }

          if (node.classList && node.classList.contains('sov-card-gallery')) {
            wireGallery(node);
          } else {
            scan(node);
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    scan(document);
    setupMutationObserver();
  });

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
